import { render } from "./GetProducts.vue?vue&type=template&id=7b6c0eff"
import script from "./GetProducts.vue?vue&type=script&lang=js"
export * from "./GetProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__